import React from 'react';
import './SyncButton.css';

function SyncButton({ onClick, hasUnsavedChanges, changesCount, disabled }) {
  return (
    <button
      className={`sync-button ${hasUnsavedChanges ? 'has-changes' : ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      {hasUnsavedChanges && (
        <span className="changes-badge">{changesCount}</span>
      )}
      Sync to Google Sheet
    </button>
  );
}

export default SyncButton;
